import { render, staticRenderFns } from "./BaseFieldLabel.vue?vue&type=template&id=f0b4bd20&"
import script from "./BaseFieldLabel.vue?vue&type=script&lang=ts&"
export * from "./BaseFieldLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports